'use client'

import { useRouter } from 'next/navigation'

export default function BackButton({
    variant,
    url,
}: Readonly<{ variant: string; url?: string }>) {
    const router = useRouter()

    return (
        <div
            className={`flex w-full max-w-60 items-center back-button-${variant}`}
            onClick={() => (url ? router.replace(url) : router.back())}
        >
            <div className="align-center m-2 flex w-full justify-between">
                <i className="bi-arrow-left text-2xl" />
                <p className="text-lg italic">Torna indietro</p>
            </div>
        </div>
    )
}
